import { ReactElement, ReactNode } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Stack, Tooltip } from '@mui/material'
import { PanelHeader } from '@ui2/structure'

interface Props {
  actions: ReactNode
  onClose: () => void
  children: ReactNode
}

/** The chat as the content of a page's right drawer: header with its controls, then the chat. */
const ChatDrawer = ({ actions, onClose, children }: Props): ReactElement => (
  <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
    <PanelHeader
      title="KI-Chat"
      action={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {actions}
          <Tooltip title="KI-Chat schließen">
            <IconButton size="small" onClick={onClose} data-cy="ai-chat-close">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      }
    />
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', px: 1, pb: 1 }}>
      {children}
    </Box>
  </Box>
)

export default ChatDrawer
